<template>
	<div class="main">
		<a-table
			:columns="columns"
			:dataSource="dataSource"
			:pagination="false"
			row-key="id"
			:rowClassName="changecolor"
			:row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
		>
			<template v-slot:tindex="_,__,index">
				{{ index+1 }}
			</template>
			<template v-slot:sex="text">
				{{ getxingbie(text) }}
			</template>
			<template v-slot:age="text">
				{{ getnianling(text) }}
			</template>
			<template v-slot:price="_,record">
				{{ getprice(record) }}
			</template>
			<template v-slot:action="id,{type,status,hetonglingquinfo}">
				<a class="tAction" @click="godetial(id)"><a-icon type="vertical-align-bottom" /> 查看导出</a>
				<a-divider type="vertical" />
				<a class="tAction" @click="confirmfn(id,type)">确认已修改</a>
				<a-divider type="vertical" />
				<a class="tAction"  v-if="(type == 8 || type == 9) && status >= 3"  @click="showsunhao(id,hetonglingquinfo)">损耗</a>
				<!-- <a class="tAction"    @click="showsunhao(id,hetonglingquinfo)">损耗</a> -->
			</template>
		</a-table>
		<Sunhao ref="sunhaoref" :reload="reload"></Sunhao>
	</div>
</template>

<script>

import {getContractList,updateContract,checkall,exportall} from "@/api/contract.js"
import moment from 'moment';
import {birthDate,gender} from 'chinese-idcard-checker';
import {columns} from './data';
import { changecolor } from '@/components/commen.js';
import Sunhao from '../sunhao.vue';

export default {
	data(){
		return {
			columns,
			dataSource:[],
			loading:false,
			selectedRowKeys:[],
		}
	},
	components:{Sunhao},
	props:["godetial","confirmfn","reload"],
	methods:{
		showsunhao(id,hetonglingquinfo){
			if(typeof hetonglingquinfo == "string"){
				hetonglingquinfo = JSON.parse(hetonglingquinfo)
			}
			this.$refs.sunhaoref.showsunhao({hetonglingquinfo,id})
		},
		changecolor,
		getlist(parm){
			this.loading = true
			return getContractList(parm).then(ret=>{
				this.loading = false
                let {rows}= ret.data;
                this.dataSource = rows
				return ret.data
			})
		},
		getdataSource(){
			return this.dataSource
		},
		getnianling(idcardnum){
			if(idcardnum){
				return moment().diff(moment(birthDate(idcardnum)),"years")||"-";
			}
			return "-"
		},
		getxingbie(idcardnum){
			if(idcardnum){
				return gender(idcardnum) 
			}
			return "-"
		},
		getprice(record){
			let {price,jieyu} = record
			if(jieyu){
				return jieyu
			}else{
				return price
			}
		},
		onSelectChange(selectedRowKeys){
			this.selectedRowKeys = selectedRowKeys;
		},
		getSlts(){
			return this.selectedRowKeys
		},
		setSlts(val){
			this.selectedRowKeys = val
		}
	}
}
</script>
<style>
.bianhong{
	color: red;
}
.bianlv{
	color: green;
}
.bianhuang{
	color: #9C27B0 ;
}
</style>


